import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { InitialState, WorkFileTrackingState } from './types'
import { identification } from './identification'
import { workFile } from './work-file'
import { RootState } from '@/store/types';

const namespaced: boolean = true

export const workFileTracking: Module<WorkFileTrackingState, RootState> = {
  namespaced,
  state: InitialState,
  getters,
  actions,
  mutations,
  modules: {
    identification,
    workFile
  }
}
